/**
 * iOS and iPadOS. iPadOS reports itself as a Mac, so it is recognised by its touch screen.
 */
export function isIOS(): boolean {
	return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

/**
 * Whether we have to offer our own "take picture / pick from gallery" choice for image uploads.
 *
 * Chrome on Android opens the system photo picker for image-only file inputs, which has no camera
 * option. iOS offers both in its native sheet, and on desktop there is no camera to capture from.
 *
 * This deliberately looks at the primary pointer instead of the screen width or the user agent:
 * tablets in landscape are as wide as a laptop, and Chrome on Android tablets requests the desktop
 * site (with a desktop user agent) by default.
 */
export function needsCameraChoice(): boolean {
	return !isIOS() && window.matchMedia?.('(pointer: coarse)').matches === true;
}
